/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import {
  defaultListTaskHumanUserId,
  iListTaskHumanUserId,
} from "../../interfaces/bonita/listTaskHumanUserId";
import { iServiceRequestCase } from "../../interfaces/bonita/serviceRequestCase";
import { iServiceRequestTask } from "../../interfaces/bonita/serviceRequestTask";
import { iItemConfiguracion } from "../../interfaces/backendApi/itemConfiguracion";
import {
  iIniciarSession,
  inicarSessionData,
} from "../../interfaces/backendApi/iniciarsession";

export const selectStoreCasoActivoPorIdContextBackend = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks

  const { casoActivoPorIdContext } = useSelector(
    (store: RootState) => store.itemCasoActivoPorIdContext
  );
  const [state, setState] = useState(casoActivoPorIdContext);
  const objListCaseAndContext: iServiceRequestCase = JSON.parse(
    JSON.stringify(state)
  );
  return objListCaseAndContext;
};

export const selectStoreTareaPorId = () => {
  const { tareaPorId: tareaPorId_ } = useSelector(
    (store: RootState) => store.tareaPorId
  );
  const [tareaPorId, setTareaPorId] = useState(tareaPorId_);
  const [state, setState] = useState(null);
  useEffect(() => {
    if (tareaPorId.length > 0) {
      setState(tareaPorId[0]);
    } else {
      console.error("serviceRequestActived está vacío");
    }
  }, [tareaPorId]);

  const objListTaskHumanUserId: iListTaskHumanUserId = JSON.parse(
    JSON.stringify(state) || JSON.stringify(defaultListTaskHumanUserId)
  );

  return objListTaskHumanUserId;
};

export const selectStoreUsuarioActivo = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const {
    clientesAdministrados,
    UsuarioBonitaBackend,
    UsuarioBackend,
    IdPerfil,
    IdCliente,
    Permisos,
    CategoriaIdCategoria,
    usuario,
    CasoSimplificado,
    SolicitudCargaManual,
    NombreCliente,
  } = useSelector((store: RootState) => store.login);

  const [usuarioStore, setUsuarioActivo] = useState({
    clientesAdministrados,
    UsuarioBonitaBackend,
    UsuarioBackend,
    IdPerfil,
    IdCliente,
    Permisos,
    CategoriaIdCategoria,
    usuario,
    CasoSimplificado,
    SolicitudCargaManual,
    NombreCliente,
  });
  return usuarioStore;
};

export const selectStoreitemConfiguracionBackend = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { itemConfiguracionBackend } = useSelector(
    (store: RootState) => store.itemConfiguracion
  );
  const [state, setState] = useState(itemConfiguracionBackend);
  const obj: iItemConfiguracion = JSON.parse(JSON.stringify(state));

  return obj;
};
//
export const selectStoreLoginBackend = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { loginBackend } = useSelector((store: RootState) => store.login);
  const [state, setState] = useState(loginBackend);
  const obj: iIniciarSession = JSON.parse(JSON.stringify(state));

  return obj;
};
export const selectStoreBackendIniciarSesion = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { loginBackend } = useSelector((store: RootState) => store.login);
  const [state, setState] = useState(loginBackend);
  const obj: inicarSessionData = JSON.parse(JSON.stringify(state));

  const jsonString = sessionStorage.getItem("usuario");
  const Cliente = JSON.parse(jsonString + "");
  return Cliente;
};
